var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_shared.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_shared.js
// module chunks = 168707334958949